import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["product", "isLoading", "fetchProductCallback", "trackingOptions", "footerPortal", "className", "toggleQuickView", "overrideAddToTrolley", "overrideAddToTrolleyText", "hideVariants", "availability", "onProductChange", "showReviews", "data-test", "onFullDetailsClick", "onSlideChanged"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react/no-array-index-key */
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { AddToTrolley, Slider, Button, Image, Ratings } from '@sainsburys-tech/bolt';
import { idify } from '@sainsburys-tech/boltui-utils';
import Status from '../Status/Status';
import Colours from '../Colours/Colours';
import VariantDropdown from '../VariantDropdown/VariantDropdown';
import { getTrackingParams, onAddToTrolleyModalOpen } from '../../tracking';
import formatProductData from '../../helpers/formatProductData';
import Availability from '../Availability/Availability';
import * as Styled from './Content.styles';

var Content = function Content(_ref) {
  var product = _ref.product,
      isLoading = _ref.isLoading,
      fetchProductCallback = _ref.fetchProductCallback,
      trackingOptions = _ref.trackingOptions,
      footerPortal = _ref.footerPortal,
      className = _ref.className,
      toggleQuickView = _ref.toggleQuickView,
      overrideAddToTrolley = _ref.overrideAddToTrolley,
      overrideAddToTrolleyText = _ref.overrideAddToTrolleyText,
      hideVariants = _ref.hideVariants,
      availability = _ref.availability,
      onProductChange = _ref.onProductChange,
      showReviews = _ref.showReviews,
      dataTest = _ref['data-test'],
      onFullDetailsClick = _ref.onFullDetailsClick,
      _onSlideChanged = _ref.onSlideChanged,
      props = _objectWithoutProperties(_ref, _excluded);

  if (isLoading) return /*#__PURE__*/React.createElement(Status, {
    type: "loading"
  });
  if (!product || product.data.status === 404) return /*#__PURE__*/React.createElement(Status, {
    type: "error"
  });

  var _formatProductData = formatProductData(product),
      name = _formatProductData.name,
      id = _formatProductData.id,
      description = _formatProductData.description,
      price = _formatProductData.price,
      _formatProductData$im = _formatProductData.images,
      images = _formatProductData$im === void 0 ? [] : _formatProductData$im,
      reviews = _formatProductData.reviews,
      variants = _formatProductData.variants;

  var clickAddToTrolley = function clickAddToTrolley() {
    onAddToTrolleyModalOpen({
      id: product.data.id,
      price: price.now
    }, window, trackingOptions);
    toggleQuickView();
  };

  var sliderImages = images.map(function (src, key) {
    return /*#__PURE__*/React.createElement(Image, {
      src: src,
      width: 250,
      height: 250,
      alt: "".concat(name, " Image ").concat(key + 1),
      responsive: true,
      style: {
        minHeight: '250px'
      },
      key: key
    });
  });
  var itemsPerSlide = {
    itemsPerSlideXs: 1,
    itemsPerSlideSm: 1,
    itemsPerSlideMd: 1,
    itemsPerSlideLg: 1
  };

  var sliderOptions = _objectSpread(_objectSpread({}, itemsPerSlide), {}, {
    isInfiniteCycle: true,
    items: sliderImages,
    navStyle: 'withSlideCount',
    onSlideChanged: function onSlideChanged(newIndex) {
      return _onSlideChanged(newIndex, sliderImages.length);
    }
  });

  var hasVariants = variants.length > 0 && !hideVariants;
  var variantsList = {};

  if (hasVariants) {
    variants.forEach(function (variant) {
      var type = variant.type,
          products = variant.products;
      variantsList[type] = products;
    });
  } // In theory a product can have 2 variant types maximum, so
  // two columns is the max that this component supports


  var types = Object.keys(variantsList);
  var columnCount = types.length;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", _extends({
    className: className,
    "data-test": dataTest
  }, props), /*#__PURE__*/React.createElement(Slider, _extends({}, sliderOptions, {
    "data-test": "".concat(dataTest, "-slider")
  })), /*#__PURE__*/React.createElement("h4", {
    "data-test": "".concat(dataTest, "-title")
  }, name), showReviews && reviews.avgRating > 0 && /*#__PURE__*/React.createElement(Ratings, {
    rating: reviews.avgRating,
    reviewsCount: reviews.reviewCount,
    "data-test": "".concat(dataTest, "-ratings"),
    style: {
      marginBottom: '8px'
    }
  }), /*#__PURE__*/React.createElement("h4", {
    "data-test": "".concat(dataTest, "-price")
  }, "\xA3", price.now.toFixed(2), price.was && /*#__PURE__*/React.createElement(React.Fragment, null, price.flashText && /*#__PURE__*/React.createElement(Styled.SalePrice, null, " ".concat(price.flashText)), /*#__PURE__*/React.createElement(Styled.WasPrice, null, "\xA3", price.was.toFixed(2)))), /*#__PURE__*/React.createElement(Availability, {
    availability: availability
  }), /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("strong", null, "About this product")), /*#__PURE__*/React.createElement(Styled.Content, {
    dangerouslySetInnerHTML: {
      __html: description
    },
    "data-test": "".concat(dataTest, "-description")
  })), footerPortal && /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, hasVariants && /*#__PURE__*/React.createElement(Styled.Variants, {
    className: "xs-row"
  }, Object.keys(variantsList).sort(function (type) {
    return type === 'Colour' ? -1 : 0;
  }) // Colour should always be on the left
  .map(function (type, index) {
    var VariantSelector = type === 'Colour' ? Colours : VariantDropdown;

    var onCallback = function onCallback(productId) {
      fetchProductCallback(productId);
      onProductChange(productId, type);
    };

    return /*#__PURE__*/React.createElement(VariantSelector, {
      key: type,
      currentPartNumber: id,
      variants: variantsList[type],
      type: type,
      index: index,
      colSize: columnCount > 1 ? 6 : 12,
      callback: function callback(productId) {
        return onCallback(productId);
      },
      "data-test": "".concat(dataTest, "-variant-selector-").concat(idify(type))
    });
  })), /*#__PURE__*/React.createElement("div", {
    className: "xs-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "xs-6--none"
  }, overrideAddToTrolley ? /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      overrideAddToTrolley(id);
    },
    kind: "primary",
    full: true,
    "data-test": "".concat(dataTest, "-button-att-override")
  }, overrideAddToTrolleyText || 'Save') : /*#__PURE__*/React.createElement(AddToTrolley.Button, {
    partNumber: id,
    name: name,
    full: true,
    onClick: clickAddToTrolley,
    openView: true,
    "data-test": "".concat(dataTest, "-button-att")
  })), /*#__PURE__*/React.createElement("div", {
    className: "xs-6--none",
    style: {
      paddingLeft: '5px'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    as: "a",
    href: "/product/".concat(id).concat(getTrackingParams(trackingOptions, id)),
    kind: "secondary",
    full: true,
    "data-test": "".concat(dataTest, "-button-full-details"),
    onClick: onFullDetailsClick
  }, "Full Details")))), window.document.querySelector("#".concat(footerPortal))));
};

Content.displayName = 'Content';
Content.propTypes = {
  product: PropTypes.shape({
    data: PropTypes.object,
    included: PropTypes.array
  }),
  fetchProductCallback: PropTypes.func,
  isLoading: PropTypes.bool,
  toggleQuickView: PropTypes.func,
  trackingOptions: PropTypes.shape({
    type: PropTypes.string,
    clickOrigin: PropTypes.string,
    eventName: PropTypes.string,
    queryParams: PropTypes.object
  }),
  footerPortal: PropTypes.string,
  availability: PropTypes.shape({
    collection: {
      available: PropTypes.bool
    },
    delivery: {
      available: PropTypes.bool
    }
  }),
  onProductChange: PropTypes.func,
  showReviews: PropTypes.bool,
  onFullDetailsClick: PropTypes.func,
  onSlideChanged: PropTypes.func
};
Content.defaultProps = {
  isLoading: true,
  showReviews: true
};
export default Content;